/*
 * TULIA CUSTOM: write-a-review page (sections/tulia-write-review.liquid).
 *
 * Reads the review code from the link (?c=<payload>.<signature>), decodes the product list
 * in the payload and builds one review block per product. It never checks the signature:
 * the Mac Mini checks every code when it reads the submission.
 *
 * Payload: base64url(JSON) with {"o": order id, "p": [[product id, "handle"], ...], "e": expiry}.
 * Field names are a fixed interface shared with the Mini (contact[Item N product|rating|review|skipped]).
 * No dependencies.
 */
(function () {
  'use strict';

  var BASE64URL = /^[A-Za-z0-9_-]+$/;

  // Returns {products: [{id, handle}, ...] in payload order, expires: unix seconds},
  // or null when the code is missing or cannot be read.
  function decodeCode(code) {
    if (!code) return null;
    var parts = code.split('.');
    if (parts.length !== 2 || !BASE64URL.test(parts[0]) || !BASE64URL.test(parts[1])) return null;

    var base64 = parts[0].replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) base64 += '=';

    var data;
    try {
      var binary = window.atob(base64);
      var bytes = new Uint8Array(binary.length);
      for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      data = JSON.parse(new TextDecoder('utf-8', { fatal: true }).decode(bytes));
    } catch (error) {
      return null;
    }
    if (!data || !Array.isArray(data.p) || data.p.length === 0) return null;
    if (typeof data.e !== 'number' || !isFinite(data.e)) return null;

    var products = [];
    for (var j = 0; j < data.p.length; j++) {
      var entry = data.p[j];
      if (!Array.isArray(entry)) return null;
      var id = entry[0];
      var handle = entry[1];
      if (!Number.isSafeInteger(id) || id <= 0 || typeof handle !== 'string' || handle === '') return null;
      products.push({ id: id, handle: handle });
    }
    return { products: products, expires: data.e };
  }

  function productImageUrl(src) {
    if (typeof src !== 'string' || src === '') return null;
    try {
      var url = new URL(src, window.location.href);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
      url.searchParams.set('width', '160');
      return url.toString();
    } catch (error) {
      return null;
    }
  }

  function loadProduct(item, handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        if (!product) return;
        if (typeof product.title === 'string' && product.title !== '') {
          item.title.textContent = product.title;
          item.legend.textContent = product.title;
        }
        var src = productImageUrl(product.featured_image);
        if (src) {
          var img = document.createElement('img');
          img.src = src;
          img.alt = '';
          img.width = 54;
          img.height = 64;
          item.image.appendChild(img);
        }
      })
      .catch(function () {
        // Keep the generic "Item from your order" title; the review still works.
      });
  }

  function buildItem(template, product, number) {
    var fragment = template.content.cloneNode(true);
    var element = fragment.querySelector('.tulia-review-item');
    var prefix = 'TuliaWriteReview-item-' + number;
    var item = {
      element: element,
      fragment: fragment,
      skipped: false,
      legend: element.querySelector('[data-item-legend]'),
      title: element.querySelector('[data-item-title]'),
      image: element.querySelector('[data-item-image]'),
      productInput: element.querySelector('[data-item-field="product"]'),
      ratingInput: element.querySelector('[data-item-field="rating"]'),
      skippedInput: element.querySelector('[data-item-field="skipped"]'),
      textarea: element.querySelector('[data-item-field="review"]'),
      picker: element.querySelector('[data-item-picker]'),
      stars: Array.prototype.slice.call(element.querySelectorAll('[data-item-star]')),
      hint: element.querySelector('[data-item-hint]'),
      skipButton: element.querySelector('[data-item-skip]'),
    };

    var label = 'contact[Item ' + number + ' ';
    item.productInput.name = label + 'product]';
    item.productInput.value = String(product.id);
    item.ratingInput.name = label + 'rating]';
    item.ratingInput.value = '';
    item.skippedInput.name = label + 'skipped]';
    item.skippedInput.value = '';
    item.textarea.name = label + 'review]';
    item.textarea.id = prefix + '-review';
    element.querySelector('[data-item-review-label]').setAttribute('for', item.textarea.id);

    var ratingLabel = element.querySelector('[data-item-rating-label]');
    ratingLabel.id = prefix + '-rating';
    item.picker.setAttribute('aria-labelledby', ratingLabel.id);

    // The star radios only drive the picker. Their form attribute names no form, so they
    // are never sent; the rating goes out in the hidden contact[Item N rating] field.
    item.stars.forEach(function (star) {
      star.name = prefix + '-stars';
      star.setAttribute('form', prefix + '-stars-only');
    });

    setUpPicker(item);
    setUpSkip(item);
    return item;
  }

  function setUpPicker(item) {
    var hints = (item.picker.getAttribute('data-hints') || '').split('|');
    var labels = item.stars.map(function (star) {
      return star.closest('.tulia-star-picker__star');
    });

    function paint(value) {
      labels.forEach(function (label, index) {
        label.classList.toggle('is-on', index < value);
      });
    }

    function selected() {
      return Number(item.ratingInput.value) || 0;
    }

    item.stars.forEach(function (star, index) {
      star.addEventListener('change', function () {
        if (!star.checked) return;
        item.ratingInput.value = star.value;
        if (hints[index + 1]) item.hint.textContent = hints[index + 1];
        paint(index + 1);
      });
      labels[index].addEventListener('mouseenter', function () {
        paint(index + 1);
      });
    });
    item.picker.addEventListener('mouseleave', function () {
      paint(selected());
    });
  }

  function setUpSkip(item) {
    var button = item.skipButton;
    button.addEventListener('click', function () {
      item.skipped = !item.skipped;
      item.skippedInput.value = item.skipped ? 'yes' : '';
      item.element.classList.toggle('is-skipped', item.skipped);
      button.setAttribute('aria-pressed', item.skipped ? 'true' : 'false');
      button.textContent = button.getAttribute(item.skipped ? 'data-unskip-text' : 'data-skip-text');
    });
  }

  function isComplete(item) {
    return !item.skipped && item.ratingInput.value !== '' && item.textarea.value.trim() !== '';
  }

  function focusFirstGap(items) {
    var open = items.filter(function (item) {
      return !item.skipped;
    });
    if (open.length === 0) {
      items[0].skipButton.focus();
    } else if (open[0].ratingInput.value === '') {
      open[0].stars[0].focus();
    } else {
      open[0].textarea.focus();
    }
  }

  function init() {
    var root = document.querySelector('[data-tulia-write-review]');
    if (!root) return;
    var fields = root.querySelector('[data-tulia-review-fields]');
    if (!fields) return; // Thank-you state: nothing to build.

    var form = fields.closest('form');
    var missing = root.querySelector('[data-tulia-review-missing]');
    var expired = root.querySelector('[data-tulia-review-expired]');
    var template = root.querySelector('[data-tulia-review-item-template]');
    var itemsBox = fields.querySelector('[data-tulia-review-items]');
    var invalid = fields.querySelector('[data-tulia-review-invalid]');
    var codeInput = fields.querySelector('[data-tulia-review-code]');

    var code = new URLSearchParams(window.location.search).get('c');
    var payload = decodeCode(code);
    if (!payload || !form || !template || !itemsBox || !codeInput) {
      fields.remove();
      if (missing) missing.hidden = false;
      return;
    }
    // Expiry is read from the payload only; the signature is still checked by the Mini alone.
    if (payload.expires * 1000 < Date.now()) {
      fields.remove();
      if (expired) expired.hidden = false;
      return;
    }
    var products = payload.products;

    codeInput.value = code;

    var items = products.map(function (product, index) {
      var item = buildItem(template, product, index + 1);
      itemsBox.appendChild(item.fragment);
      loadProduct(item, product.handle);
      return item;
    });

    var leadExtra = fields.querySelector('[data-tulia-review-lead-extra]');
    if (leadExtra && items.length > 1) {
      leadExtra.textContent = fields.getAttribute(items.length === 2 ? 'data-lead-two' : 'data-lead-many') || '';
    }

    fields.hidden = false;

    // Capture phase, so an incomplete form stops here before Shopify's spam check sees the submit.
    form.addEventListener(
      'submit',
      function (event) {
        if (items.some(isComplete)) {
          invalid.hidden = true;
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        invalid.hidden = false;
        focusFirstGap(items);
      },
      true
    );

    form.addEventListener('input', function () {
      if (!invalid.hidden && items.some(isComplete)) invalid.hidden = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
